import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import { Chart, Line } from 'react-chartjs-2'
import { MwSpinnerButton } from '../ui';

ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
)

const LineChart = ({ label, datasetData, loading, className }) => {
    const data = {
        labels: ['يناير', 'فبراير', 'مارس', 'ابريل', 'مايو', 'يونيو', 'يوليو', 'اغسطس', 'سمبتمبر', 'اكتوبر', 'نوفمبر', 'ديسمبر'],
        datasets: [
            {
                label: label,
                data: datasetData,
                borderColor: '#f5b800',
                backgroundColor: 'rgba(245, 184, 0, 0.12)',
                fill: true,
                tension: 0.4,
                pointBackgroundColor: '#08203f',
                pointBorderColor: '#fff',
                pointHoverRadius: 6,
            }
        ]
    }
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 14,
                        family: '"Tajawal", sans-serif',
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    color: 'rgba(0, 0, 0, 0.05)',
                }
            },
            x: {
                grid: {
                    display: false,
                }
            }
        }
    }

    return (
        <div className='relative w-full h-full min-h-[300px]'>
            {!loading ? (
                <Line
                    className={className}
                    data={data}
                    options={options}
                />
            ) : (
                <MwSpinnerButton withLabel={false} isFullCenter={true} />
            )}
        </div>
    )
}

export default LineChart
